/**
 * Возраст сессии Telegram-аккаунта: свежая (моложе суток) сессия ограничена в действиях.
 * Смена прокси (KAN-650) требует подтверждения, проверка через @SpamBot (KAN-661) запрещена:
 * сервер отвечает 409 с кодом `fresh_session`. Чистые функции над строкой таблицы.
 */
import type { TelegramAccount } from '@/types/telegramAccount';

/** Код ответа API 409 для действия, запрещённого свежей сессии. */
export const FRESH_SESSION_CODE = 'fresh_session';

const HOUR_MS = 60 * 60 * 1000;
/** Срок свежести сессии: сутки после входа (как на сервере). */
export const FRESH_SESSION_AGE_MS = 24 * HOUR_MS;

/** Время последнего входа (повторный вход, подключение или импорт) в мс или null, если дат нет. */
export function lastLoginTime(account: TelegramAccount): number | null {
  const stamps = [account.last_relogin_at, account.connected_at, account.imported_at]
    .map((v) => (v ? Date.parse(v) : NaN))
    .filter((t) => !Number.isNaN(t));
  return stamps.length ? Math.max(...stamps) : null;
}

/** Сессия моложе суток: последний вход (повторный вход или первое подключение) меньше 24 ч назад. */
export function isFreshSession(account: TelegramAccount, now: Date = new Date()): boolean {
  const login = lastLoginTime(account);
  return login !== null && now.getTime() - login < FRESH_SESSION_AGE_MS;
}

/** Через сколько часов (округление вверх, минимум 1) сессия перестанет быть свежей; не свежая - 0. */
export function freshHoursLeft(account: TelegramAccount, now: Date = new Date()): number {
  const login = lastLoginTime(account);
  if (login === null) return 0;
  const left = login + FRESH_SESSION_AGE_MS - now.getTime();
  if (left <= 0) return 0;
  return Math.max(1, Math.ceil(left / HOUR_MS));
}

/** Подсказка у заблокированной кнопки "Проверить" (KAN-661). */
export function checkAvailableHint(hours: number): string {
  return `Проверка доступна через ${hours} ч`;
}
